module.exports = __webpack_public_path__ + "static/img/TAKEUCHI.e6d88d42.png";